import AutoLoadingButton from "@/components/AutoLoadingButton";
import { useModalStore } from "@/hooks/Modal/hooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { updateDoNotIncreaseQuantityWhenRecycle } from "@/services/api/sharedEwaybillShippingAddress";
import { Button, Checkbox, Form, message, Modal } from "antd";
import { observer } from "mobx-react";
import React from "react";

interface RecycleSettingButtonProps {
  shippingAddressId: number;
  onRefresh;
  doNotIncreaseQuantityWhenRecycle: boolean;
}

interface RecycleSettingModalProps extends InjectBaseModalProps, RecycleSettingButtonProps {}

const RecycleSettingModal: React.FC<RecycleSettingModalProps> = function (props) {
  const { onCancel, visible, doNotIncreaseQuantityWhenRecycle, shippingAddressId, onRefresh } = props;

  const [form] = Form.useForm<{ doNotIncreaseQuantityWhenRecycle: boolean }>();

  return (
    <Modal
      onCancel={onCancel}
      visible={visible}
      title="回收设置"
      width={600}
      footer={
        <>
          <Button onClick={onCancel}>关闭</Button>
          <AutoLoadingButton
            type="primary"
            onClick={async () => {
              const { doNotIncreaseQuantityWhenRecycle } = await form.validateFields();

              await updateDoNotIncreaseQuantityWhenRecycle(shippingAddressId, doNotIncreaseQuantityWhenRecycle);

              message.success("保存成功");

              onCancel();

              onRefresh();
            }}
          >
            保存设置
          </AutoLoadingButton>
        </>
      }
    >
      <Form form={form}>
        <Form.Item
          label="回收设置"
          name="doNotIncreaseQuantityWhenRecycle"
          valuePropName="checked"
          initialValue={doNotIncreaseQuantityWhenRecycle}
        >
          <Checkbox>使用面单的人回收单号后，不增加共享余额</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const RecycleSettingButton: React.FC<RecycleSettingButtonProps> = function (props) {
  const { shippingAddressId, onRefresh, doNotIncreaseQuantityWhenRecycle } = props;
  const modalStore = useModalStore();

  function handleOpenRecycleSettingModal() {
    modalStore.openModal(RecycleSettingModal, {
      shippingAddressId,
      onRefresh,
      doNotIncreaseQuantityWhenRecycle,
    });
  }

  return (
    <Button type="link" size="small" onClick={handleOpenRecycleSettingModal}>
      回收设置
    </Button>
  );
};

export default observer(RecycleSettingButton);
